import { Path } from '../../models'

import { isSamePath } from './isSamePath'

export const isContextMenuPath = isSamePath(Path.ContextMenu)
